/* eslint-disable no-unused-vars */
import apiUpload from '@/helpers/apiUpload';

export default {
  async getUploadedHomeworks({ commit }, { studentId, homeworkId }) {
    const response = await apiUpload.get(`homework/files/listing/${studentId}/${homeworkId}`);
    const { data } = response.data;
    commit('setUploadedHomeworks', data);
  },

  async removeUploadedHomework({ state, commit }, payload) {
    // eslint-disable-next-line camelcase
    const { file_id } = payload;
    await apiUpload.delete('homework/files/delete', { params: payload });


    commit('removeUploadedHomework', file_id);
  },

  async removeHomework(state, payload) {
    await apiUpload.delete('homework/files/delete', { params: payload });
  },

  async sendUploadedHomeworks(state, payload) {
    await apiUpload.post('homework/notify', payload);
  },

  clearUploadedHomeworks({ commit }) {
    commit('clearUploadedHomeworks');
  },
};
